import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';
import Neutral from './Neutral';
import NeutralInverse from './NeutralInverse';
import Brand from './Brand';
import Dot from './Dot';
import Number from './Number';

export default {
  Warning,
  Error,
  Success,
  Info,
  Neutral,
  NeutralInverse,
  Brand,
  Dot,
  Number,
};

export const WarningBadge = Warning;
export const ErrorBadge = Error;
export const SuccessBadge = Success;
export const InfoBadge = Info;
export const NeutralBadge = Neutral;
export const NeutralInverseBadge = NeutralInverse;
export const BrandBadge = Brand;
export const DotBadge = Dot;
export const NumberBadge = Number;
